import { Heading } from "ui-components/heading";
import { Logo } from "ui-components/logo";
import { Text } from "ui-components/text";

const AuthLayout = ({ title, description, children }: { title: string; description: string; children: React.ReactNode }) => {
  return (
    <div className="bg-[linear-gradient(0deg,rgba(255,255,255,0.92)_0%,rgba(255,255,255,0.92)_100%),linear-gradient(25deg,#5D54ED_-6.48%,#9D2EEB_29.02%,#FF4C00_75.72%)] flex justify-center items-center h-screen">
      <div className="flex w-[404px] p-10 flex-col items-start gap-5 rounded-xl bg-white shadow">
        <div className="flex justify-center w-full">
          <Logo variant="icon" />
        </div>
        <div className="flex flex-col justify-center items-center w-full">
          <Heading size="tiny">{title}</Heading>
          <Text type="label" size="small" fontColor="tertiary" className="text-center">
            {description}
          </Text>
        </div>

        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
